module.exports = __webpack_public_path__ + "static/media/bibeba-logo.4e2b98a5.png";